/** Short teaser for menu list cards; full pairing text stays in `description`. */
export const getMenuItemTeaser = (item) => {
  if (!item) {
    return '';
  }
  if (item.summary) {
    return item.summary;
  }
  const text = item.description || '';
  const firstSentence = text.match(/^[^.!?]+[.!?]?/);
  return (firstSentence ? firstSentence[0] : text).trim();
};

export const findMenuItem = (menu, itemId) => {
  if (!menu?.sections || !itemId) {
    return null;
  }
  for (const section of menu.sections) {
    const item = section.items?.find((entry) => entry.id === itemId);
    if (item) {
      return item;
    }
  }
  return null;
};

export const resolveMenuWines = (item, wines) => {
  if (!item?.wineSlugs?.length || !Array.isArray(wines)) {
    return { featured: null, others: [] };
  }

  const bySlug = new Map(
    wines
      .filter((wine) => wine.visible !== false)
      .map((wine) => [wine.slug, wine])
  );

  const resolved = item.wineSlugs
    .map((slug) => bySlug.get(slug))
    .filter(Boolean);

  if (resolved.length === 0) {
    return { featured: null, others: [] };
  }

  const featuredSlug = item.featuredWineSlug;
  const featured =
    resolved.find((wine) => wine.slug === featuredSlug) || resolved[0];
  const others = resolved.filter((wine) => wine.slug !== featured.slug);

  return { featured, others };
};
